import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import createEmitter from './createEmitter';


export default function createContext(initialValue) {
    const contextProp = _.uniqueId('_react_context_');

    class ContextProvider extends PureComponent {
        constructor(props) {
            super(props);

            this.emitter = createEmitter(this.props.value);
        }

        getChildContext() {
            return { [contextProp]: this.emitter };
        }

        componentDidUpdate() {
            const { value } = this.props;

            this.emitter.publish(value);
        }

        render() {
            const { children } = this.props;
            return children ? children : null;
        }
    }

    ContextProvider.childContextTypes = {
        [contextProp]: PropTypes.object
    };

    ContextProvider.defaultProps = {
        value: initialValue
    };

    ContextProvider.propTypes = {
        children: PropTypes.element,
        value: PropTypes.any
    };

    class ContextConsumer extends PureComponent {
        constructor(props, context) {
            super(props, context);

            this.state = { value: this.getValue() };
        }

        componentDidMount() {
            if (this.context[contextProp]) {
                this.unsubscribe = this.context[contextProp].subscribe((value) => this.setState({ value }));
            }
        }

        componentWillUnmount() {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        }

        getValue() {
            return this.context[contextProp] ? this.context[contextProp].getValue() : initialValue;
        }

        render() {
            const { children } = this.props;
            return typeof children === 'function' ? children(this.state.value) : null;
        }
    }

    ContextConsumer.contextTypes = {
        [contextProp]: PropTypes.object
    };

    ContextConsumer.propTypes = {
        children: PropTypes.func
    };

    return { ContextProvider, ContextConsumer };
}



// WEBPACK FOOTER //
// ./src/context/index.js